const pxPerShare = 80;
export const minPerShare = 50;
const readablePerShare = 96;

export type Width = number | { flex: number } | undefined;

export function share(width: Width): number {
  if (width === undefined) return 1;
  if (typeof width === 'number') return Math.max(0.5, width / pxPerShare);
  return Math.max(0.5, width.flex);
}

export function relaxedMinWidth(widths: Width[]): number {
  return widths.reduce<number>((sum, w) => sum + (typeof w === 'number' ? w : share(w) * minPerShare), 0);
}

export function compactMinWidth(widths: Width[]): number {
  return widths.reduce<number>((sum, w) => sum + share(w) * minPerShare, 0);
}

export function tableMinWidth(columns: { width?: Width; minWidth?: number }[]): number {
  const total = columns.reduce<number>((sum, c) => sum + share(c.width), 0);
  return columns.reduce<number>((widest, c) => {
    const least = c.minWidth ?? share(c.width) * minPerShare;
    return Math.max(widest, (least * total) / share(c.width));
  }, 0);
}

export function readableMinWidth(widths: Width[]): number {
  return widths.reduce<number>((sum, w) => sum + share(w) * readablePerShare, 0);
}

export function shouldStack(width: number | null, widths: Width[]): boolean {
  return width !== null && widths.length > 2 && width < 600 && width < readableMinWidth(widths);
}
